/**
 * @generated SignedSource<<eb15d0610cc698f55059c4fd9f054c9d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type crawlSitesQuery$variables = Record<PropertyKey, never>;
export type crawlSitesQuery$data = {
  readonly crawlSites: ReadonlyArray<{
    readonly areasServed: string;
    readonly id: any;
    readonly isCrawlable: boolean;
    readonly name: string;
  }>;
};
export type crawlSitesQuery = {
  response: crawlSitesQuery$data;
  variables: crawlSitesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CrawlSiteSummary",
    "kind": "LinkedField",
    "name": "crawlSites",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "areasServed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isCrawlable",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "crawlSitesQuery",
    "selections": (v0/*: any*/),
    "type": "AdminQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "crawlSitesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f06131368a4d3e5bc4f337d9b5c64223",
    "id": null,
    "metadata": {},
    "name": "crawlSitesQuery",
    "operationKind": "query",
    "text": "query crawlSitesQuery {\n  crawlSites {\n    id\n    name\n    areasServed\n    isCrawlable\n  }\n}\n"
  }
};
})();

(node as any).hash = "2bfc7d6a9c59b718bc819140146a713e";

export default node;
